import { ClaimTypeEnum } from '../../lib/enum'
import { PARTNERS_WITH_ACCIDENTAL_DEATH_EVIDENCE } from '../../../../routes/PartnersEnum'

const STATIC_DOCS_BY_TYPE = {
  [ClaimTypeEnum.death]: [
    'Death certificate *',
    'Identity document *',
    'Claimant Identity document *'
  ],
  [ClaimTypeEnum.hospital]: [
    'Hospital_Invoice *',
    'Discharge_Summary *',
    'LOU_Document *'
  ],
  [ClaimTypeEnum.reimbursement]: [
    'Hospital_Invoice *',
    'Discharge_Summary *',
    'Payment Receipts *',
    'Claimants ID copy *',
    'Medical/Diagnostic Report *'
  ]
}

export const ACCIDENTAL_DEATH_EVIDENCE_DOCS = [
  'Police abstract / OB report',
  'Medical report / Hospital report'
]

export const isAccidentalDeathClaim = function (claim) {
  if (!claim) return false
  const cause = claim.additional_details && claim.additional_details.cause_of_death
  return cause === 'Accidental Death' ||
    (claim.benefits || []).some(function (benefit) {
      return benefit && benefit.type === 'Death_Accidental'
    })
}

export const getClaimDocumentChecklist = function (type, claim, partnerGuid) {
  const uploaded = (claim && claim.claim_documents) || []
  const isUploaded = function (description) {
    return uploaded.some(function (doc) { return doc.description === description })
  }

  const entries = (STATIC_DOCS_BY_TYPE[type] || []).map(function (description) {
    return { description, required: true }
  })

  if (type === ClaimTypeEnum.death &&
    PARTNERS_WITH_ACCIDENTAL_DEATH_EVIDENCE.indexOf(partnerGuid) !== -1) {
    const required = isAccidentalDeathClaim(claim)
    ACCIDENTAL_DEATH_EVIDENCE_DOCS.forEach(function (description) {
      entries.push({ description, required })
    })
  }

  return entries.map(function (entry) {
    return Object.assign({}, entry, { uploaded: isUploaded(entry.description) })
  })
}

export const hasMissingRequiredDocs = function (checklist) {
  return checklist.some(function (entry) { return entry.required && !entry.uploaded })
}
